import { render, staticRenderFns } from "./ItemMessage.vue?vue&type=template&id=0b129e38&scoped=true&"
import script from "./ItemMessage.vue?vue&type=script&lang=js&"
export * from "./ItemMessage.vue?vue&type=script&lang=js&"
import style0 from "./ItemMessage.vue?vue&type=style&index=0&id=0b129e38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b129e38",
  null
  
)

export default component.exports